import type { Mission } from '../missions.ts'

export const fincen: Mission = {
  id: "fincen",
  name: "Financial Crimes Enforcement Network",
  short: "FinCEN",
  call: "Financial Crimes",
  kind: "subagency",
  parent: "treasury",
  url: "https://www.fincen.gov/",
  established: 1990,
  palette: {
    primary: "#1e3f6a",
    secondary: "#3b6537",
    accent: "#9ecfee",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:FinCEN.svg",
  },
  motif: "shield",
  mission: {
    text: "The mission of the Financial Crimes Enforcement Network is to safeguard the financial system from illicit activity, counter money laundering and the financing of terrorism, and promote national security through strategic use of financial authorities and the collection, analysis, and dissemination of financial intelligence.",
    url: "https://www.fincen.gov/about-fincen/mission",
  },
  fact: {
    text: "FinCEN was established by order of the Secretary of the Treasury on April 25, 1990, and federal law makes it a bureau in the Department of the Treasury.",
    url: "https://www.law.cornell.edu/uscode/text/31/310",
  },
  seal: {
    file: "public/seals/fincen.png",
    source: "https://commons.wikimedia.org/wiki/File:FinCEN.svg",
  },
  identifier: {
    about: "https://www.fincen.gov/about-fincen",
    accessibility: "https://www.fincen.gov/site-policies-and-notices#accessibility",
    foia: "https://www.fincen.gov/freedom-information-act-foia-and-guide-accessing-fincen-information",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://www.fincen.gov/about-fincen/fincen-year-review",
    privacy: "https://www.fincen.gov/site-policies-and-notices#privacy-policy",
  },
}
